import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=67d31d38&"
import script from "../../../public/js/img/Discoveryjs/AutorisationJs/Roles.js?vue&type=script&lang=js&"
export * from "../../../public/js/img/Discoveryjs/AutorisationJs/Roles.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports